<template>
    <div class="middle_page_top_menu_bar">
        <div class="left_div" v-if="pageType != 'home'">
            <div class="back_btn" @click="pageBackClick()"></div>
        </div>
        <div class="right_div">
        </div>
    </div>
</template>

<script>
export default {
        props: {
            pageType: String,
            pageBackAction: Function
        },
  data() {
    return {};
  },
  computed: {
    info() {
        return this.$root.info;
    },
    label() {
        return this.$root.getLabel();
    },
    cart() {
        return this.$root.cart;
    },
    cartItemCount() {
         return this.cart.itemCount(this.$root.disableItem);
    },   
  },
  created() {
  },
  methods:{
    getItemSubfix() {
      return this.$root.getItemSubfix();
    },

    pageBackClick() {

        switch (this.pageType) {

            case "shoplist":
                this.$router.push('/');
                break;

            case "menu":
                if (this.$root.info.order_setting.autoShopSelect || this.info.order_temp_info.temp_default_shop != "") {
                    this.$router.push('/');
                } else {
                    this.$router.replace('/shop');
                }                
                break;

            case "itemDetails":
                if (this.pageBackAction != null) {
                    this.pageBackAction();
                }
                break;


            default:
                break;

        }

    }

  }
};
</script>